import React from 'react';
import { Box, Heading, Text, VStack } from '@chakra-ui/react';

const TermsPage = () => (
  <Box minH="100vh"  color="white" display="flex" alignItems="center" justifyContent="center">
    <Box p={10} bg="#181818" borderRadius="lg" boxShadow="xl" maxW="700px" w="full">
      <Heading as="h1" size="lg" mb={6}  textAlign="center" fontFamily="Audiowide">
        Terms & Conditions
      </Heading>
      <VStack align="stretch" gap={5}>
        <Text fontWeight="bold" color="#0f5a00">1. Acceptance of Terms</Text>
        <Text>
          By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement.
        </Text>
        <Text fontWeight="bold" color="#0f5a00">2. Changes to Terms</Text>
        <Text>
          We reserve the right to modify these terms at any time. You should check this page regularly.
        </Text>
        <Text fontWeight="bold" color="#0f5a00">3. User Responsibilities</Text>
        <Text>
          You agree to use the site in accordance with all applicable laws and not to misuse the site in any way.
        </Text>
        <Text fontWeight="bold" color="#0f5a00">4. Limitation of Liability</Text>
        <Text>
          The site is provided "as is" and we make no warranties, expressed or implied, regarding the site or its content.
        </Text>
        <Text fontWeight="bold" color="#0f5a00">5. Contact</Text>
        <Text>
          If you have any questions about these Terms, please contact us via the Contact Us page.
        </Text>
      </VStack>
    </Box>
  </Box>
);

export default TermsPage; 